import React, { Fragment, useState } from "react";
import { Button } from "../../common";
import Spinner from "../../common/Spinner";
import Convictions from "../../containers/Convictions";

const CriminalConvictionComp = (
  criminalConviction,
  changeItem,
  criminalConvictionDetails,
  handleSubmit,
  disableSubmitButton
) => {
  const [loading, setLoading] = useState(false);
  const [showFeedback, setFeedback] = useState(false);
  return (
    <Fragment>
      <h5 className="px-1">Criminal Conviction Details</h5>
      <Convictions
        value={criminalConviction}
        handleChange={changeItem}
        criminalConvictionDetails={criminalConvictionDetails}
      />
      <span
        className={`mx-md-2 mt-2 mt-md-0`}
        style={{
          fontSize: "12px",
          lineHeight: "14px",
          letterSpacing: "0.3px",
        }}
      >
        <p className="px-2">
          Having a criminal conviction will not necessarily exclude you from the
          process. If you fail to declare a conviction or true and completed
          information or knowingly make a false statement, this may constitute a
          criminal offence, If you are working in an assignment with a client at
          the time that we are made aware of a conviction that have not
          disclosed to us, we may be legally required to inform our client of
          that information and your assignment may be terminated.
        </p>
        <p className="px-2">
          Applications are processed through the Disclosure Barring Service
          (DBS) by GBG Online Disclosures. By providing your personal detail you
          agree to and accept to be bound by their statement of fair processing
          available within their{" "}
          <a
            href="https://storage.knowyourpeople.co.uk/files/kyp%20privacy%20policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{" "}
          and it is your responsibility to read the{" "}
          <a
            href="https://www.gov.uk/government/publications/basic-dbs-check-privacy-policy/basic-dbs-check-privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Basic DBS Processing Privacy Policy.
          </a>
        </p>
        <p className="px-2">
          Electronic results of this check will the supplied directly to HRGO
          confirming whether the certificate contains criminal records
          information, if yes, it is your responsibility to provide the
          certificate for consideration of suitability for the role, spent
          convictions will NOT be considered.
        </p>
        <p className="px-2">
          For further information regarding how your data may be handled by HR
          GO please see our Privacy Policy at{" "}
          <a
            href="https://www.hrgo.co.uk/legal-policies/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            HRGO Privacy Policy
          </a>
          .
        </p>
      </span>

      <div className="w-100 d-flex justify-content-end flex-column-reverse flex-sm-row px-2 ">
        {showFeedback ? (
          <div
            className="border-success rounded mb-1"
            style={{
              width: "100%",
              height: "42px",
              backgroundColor: "#5da370",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#FFFFFF",
            }}
          >
            {" "}
            Criminal conviction details saved{" "}
          </div>
        ) : null}
        <Button
          classes={`btn btn-primary ml-sm-1 mb-1 mb-sm-2 px-3`}
          onClick={() => {
            setLoading(true);
            handleSubmit();
            setTimeout(() => {
              setLoading(false);
              setFeedback(true);
            }, 2000);
          }}
          disabled={disableSubmitButton()}
        >
          {loading ? (
            <Fragment>
              <Spinner />
            </Fragment>
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </Fragment>
  );
};

export default CriminalConvictionComp;
